import axiosInstance from "../../../api/axiosInstance";

export const fetchCategories = async () => {
  try {
    console.log("[OfficialSentenceService] Fetching categories");
    const res = await axiosInstance.get("/public/official-sentences/categories");
    console.log("[OfficialSentenceService] Categories response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[OfficialSentenceService] Categories failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchCategoryById = async (id) => {
  try {
    console.log("[OfficialSentenceService] Fetching category by id:", id);
    const res = await axiosInstance.get(`/public/official-sentences/categories/${id}`);
    console.log("[OfficialSentenceService] Category detail response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[OfficialSentenceService] Category detail failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchOfficialSentences = async (params) => {
  try {
    const cleaned = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null));
    console.log("[OfficialSentenceService] Fetching sentences, params:", cleaned);
    const res = await axiosInstance.get("/public/official-sentences", { params: cleaned });
    console.log("[OfficialSentenceService] Sentences response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[OfficialSentenceService] Sentences failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchOfficialSentenceById = async (id) => {
  try {
    console.log("[OfficialSentenceService] Fetching sentence by id:", id);
    const res = await axiosInstance.get(`/public/official-sentences/${id}`);
    console.log("[OfficialSentenceService] Sentence detail response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[OfficialSentenceService] Sentence detail failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchSentenceOptions = async () => {
  try {
    console.log("[OfficialSentenceService] Fetching options");
    const res = await axiosInstance.get("/public/official-sentences/options");
    console.log("[OfficialSentenceService] Options response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[OfficialSentenceService] Options failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch options" };
  }
};
